import Vue from 'vue';
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: 'mdi',
    },
    theme: {
        themes: {
            light: {
                primary: '#f7901e',
                secondary: '#fdcc10',
                tertiary: '#3F51B5',
                quaternary: '#159565',
                quinary: '#CD6832',
                accent: '#f7901e',
                error: '#f7581e'
            },
        },
    },
});
